// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".538.0.0." + {"1367": "c9ba716df7c9ecba","2257": "1a3b101fd5208777","2973": "fc765b378128cb15","582": "f599062d39fedb02","7530": "51c5dff5409b3e6c","7581": "9518d75f0b94ff4f","8692": "f2f4d6346ccef458",}[chunkId] + ".css"
}